import React from 'react';

export const CheckIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" {...props}>
        <title>CheckIcon</title>
        <path
            d="M7.26227 22L21.2082 4.44768C22.2389 3.15052 22.2887 2.18789 21.2082 0.950575C20.1277 -0.286743 18.9646 -0.346613 17.9339 0.950554L7.26227 14.8639L4.57189 11.1981C3.58474 9.85308 1.91147 8.74201 0.791093 9.9271C-0.329283 11.1122 -0.196021 12.8067 0.791129 14.1517L7.26227 22Z"
            fill="currentColor"
        />
    </svg>
);
